import Http from '../../../../network/Http'
import {NatGetResidentBankAccountInfo} from './NatGetResidentBankAccountInfo'
import {SessionStorageHelper} from '../../../../SessionStorageHelper'
import {
    ResidentLoginInfoSessionStorageKey
} from '../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {LOGIN_MODE} from '../../../../CodeMaster'

export default class NatResidentBankAccountInfoRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // 口座情報取得
    async getResidentBankAccountInfo(): Promise<NatGetResidentBankAccountInfo> {
        if (SessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.LOGIN_MODE) === LOGIN_MODE.ADMIN.value) {
            return {
                details: {
                    bankName: '',
                    branchName: '',
                    depositType: '',
                    bankAccountNumber: '',
                    accountPersonHolder: 'ー'
                },
                informations: null,
                requestError: null,
                requestItemErrors: null
            }
        }
        return await this.http.get(`/api/resident/account-transfer/authed`);
    }
}
